import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function listCandidateCourses(
  actorType: string,
  id: number | string
): Promise<ApiResponse> {
  return Axios.get("v1/candidates/candidates/candidate_courses", {
    headers: { ActorType: actorType, ActorId: id },
  });
}
